<template>
  <scoped>
    <h1>
      Trademark
    </h1>
    <table v-if="trademark">
      <tbody>
        <tr>
          <th>
            Name
          </th>
          <td>
            {{ trademark.name }}
          </td>
        </tr>
        <tr>
          <th>
            Memorandum
          </th>
          <td>
            {{ trademark.memorandum }}
          </td>
        </tr>
      </tbody>
    </table>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import {Trademark as TrademarkClient} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {onBeforeMount, ref} from "vue"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"

  const props = defineProps({
    trademarkID: {
      default: null,
      required: true,
      type: String
    }
  })

  const error = ref<Error>(null)
  const trademarkClient = new TrademarkClient()
  const trademark = ref<Trademark>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      trademark.value = await trademarkClient.summary(props.trademarkID)
    } catch(e) {
      error.value = e
    }
  }
</script>
